

























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { Debouncer } from "@/models/Debouncer";
import { Parser } from "json2csv";

@Component({})
export default class extends Vue {
    public headers = [
        { text: "ID", value: "restaurant_id"},
        { text: "Restaurant", value: "restaurant_name" },
        { text: "Total Sales", value: "total_sales" },
    ];

    public fromDate: any = null;
    public toDate: any = null;

    public models: any[] = [];

    public async search() {
        try {
            const result = await app.reportService.getRestaurantsSales(
                this.fromDate,
                this.toDate
            );
            this.models = result;
        } catch (e) {
            console.log(e);
        }
    }

    public download(filename: any, data: any) {
        const element = document.createElement("a");
        element.style.display = "none";
        element.setAttribute("href", "data:text/plain," + data);
        element.setAttribute("download", filename);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    public exportToExcel() {
        const data = this.models.map(e => {
            return {
                ID: e.restaurant_id,
                RestaurantName: e.restaurant_name,
                TotalSales: e.total_sales
            };
        });

        const fields = [
            "ID",
            "RestaurantName",
            "TotalSales"
        ];

        const perser = new Parser({ fields });
        const csv = perser.parse(data);
        this.download("Report.csv", csv);
    }
}
